import gql from 'graphql-tag';

export const GET_STOCK_ORDER = gql`
  query stockOrder($id: Int!) {
    stockOrder(id: $id) {
      id
      cid
      status
      notes
      createdAt
      orderedAt
      supplier {
        id
        name
        email
      }
      orderItems {
        id
        costPrice
        quantity
        quantityReceived
        total
        product {
          id
          partNumber
          name
        }
      }
    }
  }
`;

export const UPDATE_STOCK_ORDER = gql`
  mutation updateStockOrder($input: UpdateStockOrderInput!) {
    updateStockOrder(input: $input) {
      stockOrder {
        id
      }
    }
  }
`;
